import { IExpert } from '@techspert-io/experts';

export enum CampaignEmailTemplateTypeMap {
  sendgrid = 'sendgrid',
  connect = 'connect',
}

export interface IOutreachEmailTemplate {
  name: string;
  templateId: string;
  templateType: CampaignEmailTemplateTypeMap;
  favorite: boolean;
  suggested: boolean;
  templateContent: {
    content: string;
    subject: string;
    preheader: string;
  };
  tags: string[];
}

export interface IOutreachEmailItem {
  recipientAddress: string[];
  senderUserId: string;
  sendTime: string;
  currency: string;
  honorarium: number;
  templateId: string;
  templateContent: {
    subject: string;
    preheader?: string;
    content: string;
  };
}

export interface IOutreachEmail {
  email: IOutreachEmailItem;
  expertId: string;
}
export interface IOutreachEmailRes {
  expertId: string;
  /** When no expert update is made, this field is undefined. */
  expert?: Partial<Pick<IExpert, 'connectPhase'>>;
  emails: {
    emailId: string;
    address: string;
  }[];
}
